export default __webpack_public_path__ + "static/media/illustration-friendly.18c1de56.svg";